import { dataLayerService } from '~/services/data-layer-service'
import store from '~/store'

export default (to, from, next) => {
  if (store.getters['auth/check']) {
    const user = store.getters['auth/user']
    if (user.role_id === 1 || user.role_id === 5) {
      window.location = config.adminurl + '/users'
    } else {
      dataLayerService.push({
        event: 'Auth_Successful',
        user_id: user.id,
        email: user.email,
      })

      window.location = config.userurl + '/dashboard'
    }
  } else {
    next()
  }
}
